import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ListState = {
  emailEnrichmentPks: number[];
  selectedRows: number[];
  emailEnrichmentLoading: boolean;
  error: string | null;
};

const initialState: ListState = {
  emailEnrichmentPks: [],
  selectedRows: [],
  emailEnrichmentLoading: false,
  error: null,
};

const listSlice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    setEmailEnrichmentPks: (state, action: PayloadAction<number[]>) => {
      state.emailEnrichmentPks = action.payload;
    },
    addEmailEnrichmentPk: (state, action: PayloadAction<number>) => {
      if (!state.emailEnrichmentPks.includes(action.payload)) {
        state.emailEnrichmentPks.push(action.payload);
      }
    },
    removeEmailEnrichmentPk: (state, action: PayloadAction<number>) => {
      state.emailEnrichmentPks = state.emailEnrichmentPks.filter((pk) => pk !== action.payload);
    },
    clearEmailEnrichmentPks: (state) => {
      state.emailEnrichmentPks = [];
    },
    resetListState: () => initialState,
  },
});

export const {
  setEmailEnrichmentPks,
  addEmailEnrichmentPk,
  removeEmailEnrichmentPk,
  resetListState,
  clearEmailEnrichmentPks,
} = listSlice.actions;

export default listSlice.reducer;
